/** @format */

import { apiInstanceFetch } from "../../../util/api";
import { GET_REDEEM_REQUEST, REDEEM_ACTION, ADMIN_WALLET, ACCEPTSELLERWITHDRAWALREQUEST, GET_SELLER_WITHDRAWAL_REQUEST, GET_ADMIN_EARNING, DECLINESELLERWITHDRAWALREQUEST, TRANSFER_REQUIRES_OTP, TRANSFER_OTP_FINALIZED, SET_PAYSTACK_BALANCE, SET_TRANSFER_STATUS } from "./redeem.type";
import axios from "axios";
import { setToast } from "../../../util/toast";

//get reels
export const getRedeem = (type) => (dispatch) => {
	apiInstanceFetch
		.get(`sellerWallet/sellerPendingWithdrawalRequestedAmountForAdmin`)
		.then((res) => {
			dispatch({
				type: GET_REDEEM_REQUEST,

				payload: {
					data: res.sellerPendingWithdrawalRequestedAmount,
					total: res.totalsellerPendingWithdrawalRequestedAmount,
				},
			});
		})
		.catch((error) => {
			console.log(error);
		});
};

//action for redeem request
export const action = (redeemId) => (dispatch) => {
	axios.post(`sellerWallet/byAdminToSeller?sellerWalletId=${redeemId}`)
		.then((res) => {
			if (res.status) {
				dispatch({ type: REDEEM_ACTION, payload: redeemId });

				setToast("success", "Seller Withdrawal Requested Amount Pay Successfully");
			}
		})
		.catch((error) => {
			console.log(error);
		});
};

export const getAdminWallet = () => (dispatch) => {
	apiInstanceFetch
		.get("sellerWallet/adminCommissionWallet")
		.then((res) => {
			dispatch({ type: ADMIN_WALLET, payload: res.data });
		})
		.catch((error) => {
			console.log("error", error);
		});
};

export const getWithdrawalRequest = (start, limit, startDate, endDate, type) => (dispatch) => {
	apiInstanceFetch
		.get(`withdrawRequest/listWithdrawalRequests?start=${start}&limit=${limit}&startDate=${startDate}&endDate=${endDate}&type=${type}`)
		.then((res) => {
			dispatch({ type: GET_SELLER_WITHDRAWAL_REQUEST, payload: res });
		})
		.catch((error) => {
			console.log("error", error);
		});
};

export const acceptWithdrawalRequest = (payload) => (dispatch) => {
	apiInstanceFetch
		.patch(`withdrawRequest/approveWithdrawalRequest?requestId=${payload.requestId}&personId=${payload.personId}`)
		.then((res) => {
			if (res.requiresOTP) {
				// Transfer initiated but OTP is required to finalize
				// (works whether status is true for new transfer or false for "already initiated")
				dispatch({
					type: TRANSFER_REQUIRES_OTP,
					payload: {
						requestId: res.requestId || payload.requestId,
						transferCode: res.transferCode,
					},
				});
				setToast("info", res.message || "Transfer initiated. Please enter the OTP sent to your Paystack business phone.");
			} else if (res.status) {
				// Transfer went through without OTP
				dispatch({ type: ACCEPTSELLERWITHDRAWALREQUEST, payload: payload.requestId });
				setToast("success", res.message || "Withdrawal approved and transfer initiated via Paystack.");
			} else {
				setToast("error", res.message || "Failed to approve withdrawal request.");
			}
		})
		.catch((error) => {
			console.log(error);
			setToast("error", "Failed to process withdrawal request.");
		});
};

// Finalize transfer with OTP
export const finalizeTransfer = (payload) => (dispatch) => {
	return apiInstanceFetch
		.patch(`withdrawRequest/finalizeTransfer?requestId=${payload.requestId}&otp=${payload.otp}`)
		.then((res) => {
			if (res.status) {
				dispatch({ type: TRANSFER_OTP_FINALIZED, payload: payload.requestId });
				setToast("success", res.message || "Transfer finalized successfully.");
				return { success: true };
			} else {
				setToast("error", res.message || "Failed to finalize transfer.");
				return { success: false };
			}
		})
		.catch((error) => {
			console.log(error);
			setToast("error", "Failed to finalize transfer.");
			return { success: false };
		});
};

// Resend transfer OTP
export const resendTransferOTP = (requestId) => (dispatch) => {
	apiInstanceFetch
		.post(`withdrawRequest/resendTransferOTP?requestId=${requestId}&reason=resend_otp`)
		.then((res) => {
			if (res.status) {
				setToast("success", res.message || "OTP resent successfully.");
			} else {
				setToast("error", res.message || "Failed to resend OTP.");
			}
		})
		.catch((error) => {
			console.log(error);
			setToast("error", "Failed to resend OTP.");
		});
};

// Fetch Paystack balance
export const getPaystackBalance = () => (dispatch) => {
	apiInstanceFetch
		.get("paystack/balance")
		.then((res) => {
			if (res.status) {
				dispatch({ type: SET_PAYSTACK_BALANCE, payload: res.data });
			}
		})
		.catch((error) => {
			console.log("Error fetching Paystack balance:", error);
		});
};

// Get transfer status for a withdrawal request
export const getTransferStatus = (requestId) => (dispatch) => {
	apiInstanceFetch
		.get(`withdrawRequest/transferStatus?requestId=${requestId}`)
		.then((res) => {
			if (res.status) {
				dispatch({ type: SET_TRANSFER_STATUS, payload: res.data });
			}
		})
		.catch((error) => {
			console.log("Error fetching transfer status:", error);
		});
};

export const declineWithdrawalRequest = (payload) => (dispatch) => {
	apiInstanceFetch
		.patch(`withdrawRequest/rejectWithdrawalRequest?requestId=${payload.requestId}&personId=${payload.personId}&reason=${payload.reason}`)
		.then((res) => {
			if (res.status) {
				dispatch({
					type: DECLINESELLERWITHDRAWALREQUEST,
					payload: payload.requestId,
				});
				setToast("success", "Seller Withdrawal Request Declined Successfully");
			}
		})
		.catch((error) => {
			console.log(error);
			setToast("error", "Failed to decline request");
		});
};

export const getAdminEarning = (start, limit, startDate, endDate) => (dispatch) => {
	apiInstanceFetch
		.get(`sellerWallet/fetchAdminEarnings?start=${start}&limit=${limit}&startDate=${startDate}&endDate=${endDate}`)
		.then((res) => {
			dispatch({ type: GET_ADMIN_EARNING, payload: res });
		})
		.catch((error) => {
			console.log("error", error);
		});
};
